export const colors = {
	RB_PURPLE: '#6245B7',
	PURPLE: '#3c228a',
	DARK_PURPLE: '#13014a',
	PURPLE_INACTIVE: '#9d90c4',
	PURPLE_LIGHT: 'rgba(60, 34, 138, 0.16)',
	PURLPE_BACKGROUND: '#9587bf',
	WHITE: '#ffffff',
	LIGHT_GREY: '#dadce0',
	LIGHTER_GREY: '#F1F1F2',
	DARK_GREY: '#515357',
	GREY: '#6d6e71',
	DISABLED: '#B2B0B9',
	BLACK: '#000000',
	LIGHTER_BLACK: '#2E2F32',
	LIGHT_GRAY_SHADE: '#F2F2F2',
	HOVER_GRAY_SHADE: '#f9f9f9',
	ERROR: '#cb2022',
	VOLT: '#eaf100',
	INACTIVE: '#7b7297',
	LIGHT_BLUE: '#a8b7e9',
	BLUE_ACTIVE: '#0e4fbd',
	BLUE_INACTIVE: '#86a7dd',
	MAGENTA_ACTIVE: '#a20081',
	MAGENTA_INACTIVE: '#d07fc0',
	PINK_ACTIVE: ' #e21b63',
	PINK_INACTIVE: ' #f08cb1',
	ORANGE_ACTIVE: '#ff623c',
	ORANGE_INACTIVE: '#feb09d',
	FONT_COLOR: '#333333',
	FONT_COLOR_SECONDARY: '#8B8A8E',
	OFF_WHITE: '#ffffff',
	POSITIVE_GROWTH_COLOR: '#0F9D58',
	NEGATIVE_GROWTH_COLOR: '#CB2022',
	PIE_SERIES_COLOR: '#9D90C4',
	PIE_SERIES_COLOR1: '#9B91C0',
	PIE_SERIES_COLOR2: '#634EA1',
	PIE_SERIES_COLOR3: '#EBE9F3',
	PIE_SERIES_COLOR4: '#372785',
	TOGGLE_ACTIVE: '#EBE8F3',
	COLUMN_SERIES: '#E4E1EE',
	LIGHT_PURPLE: '#7063A6',
	LIGHT_BLUE_MAGENTA: '#9283BE',
	LIGHT_HIGHLIGHT: '#EBEBEB',
	WARNING_COLOR: '#FCE8E9',
	WARNING_TEXT_COLOR: '#9B1419',
	ALERT_BG: '#F5F4F9',
	BACK_BTN: '#565656',
	BORDER_COLOR: '#FFE190',
	ALERT_COLOR: '#FFF9E9',
	ALERT_FONT_COLOR: '#662B0D',
	ERROR_FONT_COLOR: '#DE1C24',
	BG_SUCCESS: '#EAF3E6',
	TXT_SUCCESS: '#1D5F02',
	WHITE_OPACITY_8: 'rgba(255, 255, 255, 0.8)',
	WHISPER: '#ebe9f3',
	BLACK_OPACITY_1: 'rgba(0, 0, 0, 0.1)',
	SNOMO_PURPLE: '#3c228a',
	PURPLE_BLUSH: '#F0EEF6',
	BRIGHT_NAVY_BLUE: '#017ACD',
	NERO_BLACK: '#282828',
	GRAYISH_VIOLET: '#414042',
	HAWKES_BLUE: '#dadce0',
	DARK_CHARCOAL: '#333333',
	FAUX_BRIGHT_GRAY: '#ebe8f3',
	GRAY: '#3b3b3b',
	LIGHTER_GRAY: '#ededed',
	MILD_GRAY: '#F2F2F2',
	GRAYISH_BLUE: '#F1F3F4',
	ERROR_RED: '#cb2022',
	LIGHT_GRAY: '#dadce0',
	SONIC_SILVER: '#767676',
	PURPLE_MAJESTY: '#9B8CC0',
	PURPLE_MAJESTY_LITE: '#8879B9',
	LIGHT_GRAY_TEXT: '#838588',
	DARKER_GREY: '#565656',
	ERROR_RED_TEXT: '#DE1C24',
	LIGHTER_GRAY_BG: '#FBFBFB',
	BRIGHT_GRAY: '#ECE9F3',
	PHILIPPINE_SILVER: '#B2B0B9',
	DIM_GRAY: '#6C6C6C',
	LIGHT_PURPLE_TOOLTIP: '#F0EDF3'
};
